import type { Client } from '@hey-api/client-fetch';
import { listItemsinaFolder } from '../generated/services.gen';

const CONNECT_FOLDER_TYPE = 'FOLDER';

export interface ConnectChildFolder {
  readonly id: string;
  readonly name: string;
  readonly hasChildren: boolean;
}

export async function listConnectChildFolders(
  client: Client,
  folderId: string
): Promise<readonly ConnectChildFolder[]> {
  const result = await listItemsinaFolder({
    client,
    path: { folderId },
  });

  if (result.data === undefined) {
    throw new Error('Failed to list Trimble Connect folders');
  }

  return result.data.flatMap((item) => {
    if (item.type !== CONNECT_FOLDER_TYPE) {
      return [];
    }

    return [
      {
        id: item.id,
        name: item.name,
        hasChildren: item.hasChildren !== false,
      },
    ];
  });
}
